import React, { Component } from "react";
import { loadOrganisation } from "./requests";
import { EpreuvesList } from "./old/EpreuvesList";

export class OrganisationDetail extends Component {
  constructor(props) {
    super(props);

    this.state = { organisation: null };
  }

  async componentDidMount() {
    const { organisationId } = this.props.match.params;
    const organisation = await loadOrganisation(organisationId);
    this.setState({ organisation });
  }

  render() {
    const { organisation } = this.state;
    if (!organisation) {
      return null;
    }
    return (
      <div>
        <h1 className="title">{organisation.nom}</h1>
        <div className="box">{organisation.email}</div>
        <div>
          <h4>Liste des épreuves de l'organisation</h4>
          <EpreuvesList epreuves={organisation.epreuves} />
        </div>
      </div>
    );
  }
}
